/*
 * The theme's widths and paddings are content-box measurements; sanitize.css
 * makes every element border-box.
 */
*,
::before,
::after {
    box-sizing: content-box;
}

/* Controls and tables are laid out as border-box, which is what the theme
   assumes when it sizes them. */
button,
select,
table,
input[type="button"],
input[type="reset"],
input[type="submit"] {
    box-sizing: border-box;
}
